import Vue from "vue";
import { ImageRating } from "vue-rate-it";
Vue.component("image-rating", ImageRating);
